import { Asset, AssetType } from "../../../api/assets";
import { PTVerificationTypes } from "../../../api/physicalTechnicalVerifications";

export const PT_VERIFICATION_TYPE_LABELS: Record<PTVerificationTypes, string> = {
  [PTVerificationTypes.VEHICLE_VALUATION]: "Vehicle Valuation",
  [PTVerificationTypes.VEHICLE_CONDITION]: "Vehicle Condition",
  [PTVerificationTypes.VEHICLE_EXISTENCE]: "Vehicle Existence",
  [PTVerificationTypes.VEHICLE_REGISTRATION]: "Vehicle Registration",
  [PTVerificationTypes.VEHICLE_CUSTODY]: "Vehicle Custody",
  [PTVerificationTypes.VEHICLE_DEALER]: "Vehicle Dealer",
  [PTVerificationTypes.VEHICLE_IDENTITY_TAMPER]: "Vehicle Identity Tamper",

  [PTVerificationTypes.PLANT_MACHINERY_VALUATION]: "Plant & Machinery Valuation",
  [PTVerificationTypes.PLANT_MACHINERY_CONDITION]: "Plant & Machinery Condition",
  [PTVerificationTypes.PLANT_MACHINERY_EXISTENCE]: "Plant & Machinery Existence",
  [PTVerificationTypes.PLANT_MACHINERY_CUSTODY]: "Plant & Machinery Custody",
  [PTVerificationTypes.PLANT_MACHINERY_SUPPLIER]: "Plant & Machinery Supplier Genuine Check",
  [PTVerificationTypes.PLANT_MACHINERY_INSTALLATION]: "Plant & Machinery Installation Check",
  [PTVerificationTypes.PLANT_MACHINERY_SPECIFICATION]: "Plant & Machinery Specification Verification",
  [PTVerificationTypes.PLANT_MACHINERY_IDENTITY_TAMPER]: "Plant & Machinery Identity Tampering Check",

  [PTVerificationTypes.COMMERCIAL_EQUIPMENT_VALUATION]: "Commercial Equipment Valuation",
  [PTVerificationTypes.COMMERCIAL_EQUIPMENT_CONDITION]: "Commercial Equipment Condition",
  [PTVerificationTypes.COMMERCIAL_EQUIPMENT_EXISTENCE]: "Commercial Equipment Existence",
  [PTVerificationTypes.COMMERCIAL_EQUIPMENT_CUSTODY]: "Commercial Equipment Custody",
  [PTVerificationTypes.COMMERCIAL_EQUIPMENT_SUPPLIER]: "Commercial Equipment Supplier Genuine Check",
  [PTVerificationTypes.COMMERCIAL_EQUIPMENT_INSTALLATION]: "Commercial Equipment Installation Check",
  [PTVerificationTypes.COMMERCIAL_EQUIPMENT_SPECIFICATION]: "Commercial Equipment Specification Verification",
  [PTVerificationTypes.COMMERCIAL_EQUIPMENT_IDENTITY_TAMPER]: "Commercial Equipment Identity Tampering Check",

  [PTVerificationTypes.PRECIOUS_METAL_VALUATION]: "Precious Metal Valuation",
  [PTVerificationTypes.PRECIOUS_METAL_AUTHENTICITY]: "Precious Metal Authenticity",
  [PTVerificationTypes.PRECIOUS_METAL_EXISTENCE]: "Precious Metal Existence",
  [PTVerificationTypes.PRECIOUS_METAL_CUSTODY]: "Precious Metal Custody",

  [PTVerificationTypes.RESIDENTIAL_REAL_ESTATE_VALUATION]: "Residential Valuation",
  [PTVerificationTypes.RESIDENTIAL_REAL_ESTATE_DIMENSIONS]: "Residential Dimension Checks",
  [PTVerificationTypes.RESIDENTIAL_REAL_ESTATE_EXISTENCE]: "Residential Existence Verification",
  [PTVerificationTypes.RESIDENTIAL_REAL_ESTATE_CUSTODY]: "Residential Custody Verification",

  [PTVerificationTypes.COMMERCIAL_REAL_ESTATE_VALUATION]: "Commercial Valuation",
  [PTVerificationTypes.COMMERCIAL_REAL_ESTATE_DIMENSIONS]: "Commercial Dimension Checks",
  [PTVerificationTypes.COMMERCIAL_REAL_ESTATE_EXISTENCE]: "Commercial Existence Verification",
  [PTVerificationTypes.COMMERCIAL_REAL_ESTATE_CUSTODY]: "Commercial Custody Verification",

  [PTVerificationTypes.INDUSTRIAL_REAL_ESTATE_VALUATION]: "Industrial Valuation",
  [PTVerificationTypes.INDUSTRIAL_REAL_ESTATE_DIMENSIONS]: "Industrial Dimension Checks",
  [PTVerificationTypes.INDUSTRIAL_REAL_ESTATE_EXISTENCE]: "Industrial Existence Verification",
  [PTVerificationTypes.INDUSTRIAL_REAL_ESTATE_CUSTODY]: "Industrial Custody Verification",

  [PTVerificationTypes.AGRICULTURAL_LAND_PARCEL_VALUATION]: "Agricultural Land Valuation",
  [PTVerificationTypes.AGRICULTURAL_LAND_PARCEL_DIMENSIONS]: "Agricultural Land Boundary Demarcation",
  [PTVerificationTypes.AGRICULTURAL_LAND_PARCEL_EXISTENCE]: "Agricultural Land Existence Verification",
  [PTVerificationTypes.AGRICULTURAL_LAND_PARCEL_CUSTODY]: "Agricultural Land Custody Verification",

  [PTVerificationTypes.NON_AGRICULTURAL_LAND_PARCEL_VALUATION]: "Non-Agricultural Land Valuation",
  [PTVerificationTypes.NON_AGRICULTURAL_LAND_PARCEL_DIMENSIONS]: "Non-Agricultural Land Boundary Demarcation",
  [PTVerificationTypes.NON_AGRICULTURAL_LAND_PARCEL_EXISTENCE]: "Non-Agricultural Land Existence Verification",
  [PTVerificationTypes.NON_AGRICULTURAL_LAND_PARCEL_CUSTODY]: "Non-Agricultural Land Custody Verification",

  [PTVerificationTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_VALUATION]: "Industrial Allotment Valuation",
  [PTVerificationTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_DIMENSIONS]: "Industrial Allotment Boundary Demarcation",
  [PTVerificationTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_EXISTENCE]: "Industrial Allotment Existence Verification",
  [PTVerificationTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_CUSTODY]: "Industrial Allotment Custody Verification",

  [PTVerificationTypes.RESIDENTIAL_PLOT_LAND_PARCEL_VALUATION]: "Residential Plot Valuation",
  [PTVerificationTypes.RESIDENTIAL_PLOT_LAND_PARCEL_DIMENSIONS]: "Residential Plot Boundary Demarcation",
  [PTVerificationTypes.RESIDENTIAL_PLOT_LAND_PARCEL_EXISTENCE]: "Residential Plot Existence Verification",
  [PTVerificationTypes.RESIDENTIAL_PLOT_LAND_PARCEL_CUSTODY]: "Residential Plot Custody Verification",

  [PTVerificationTypes.COMMERCIAL_PLOT_LAND_PARCEL_VALUATION]: "Commercial Plot Valuation",
  [PTVerificationTypes.COMMERCIAL_PLOT_LAND_PARCEL_DIMENSIONS]: "Commercial Plot Boundary Demarcation",
  [PTVerificationTypes.COMMERCIAL_PLOT_LAND_PARCEL_EXISTENCE]: "Commercial Plot Existence Verification",
  [PTVerificationTypes.COMMERCIAL_PLOT_LAND_PARCEL_CUSTODY]: "Commercial Plot Custody Verification",

  [PTVerificationTypes.OTHERS]:"Others"
};

export const ASSET_TYPE_TO_PT_VERIFICATION_MAP: Record<AssetType, PTVerificationTypes[]> = {
  [AssetType.VEHICLE]: [
    PTVerificationTypes.VEHICLE_VALUATION,
    PTVerificationTypes.VEHICLE_CONDITION,
    PTVerificationTypes.VEHICLE_EXISTENCE,
    PTVerificationTypes.VEHICLE_REGISTRATION,
    PTVerificationTypes.VEHICLE_CUSTODY,
    PTVerificationTypes.VEHICLE_DEALER,
    PTVerificationTypes.VEHICLE_IDENTITY_TAMPER,
  ],
  [AssetType.PLANT_AND_MACHINERY]: [
    PTVerificationTypes.PLANT_MACHINERY_VALUATION,
    PTVerificationTypes.PLANT_MACHINERY_CONDITION,
    PTVerificationTypes.PLANT_MACHINERY_EXISTENCE,
    PTVerificationTypes.PLANT_MACHINERY_CUSTODY,
    PTVerificationTypes.PLANT_MACHINERY_SUPPLIER,
    PTVerificationTypes.PLANT_MACHINERY_INSTALLATION,
    PTVerificationTypes.PLANT_MACHINERY_SPECIFICATION,
    PTVerificationTypes.PLANT_MACHINERY_IDENTITY_TAMPER,
  ],
  [AssetType.COMMERCIAL_EQUIPMENT]: [
    PTVerificationTypes.COMMERCIAL_EQUIPMENT_VALUATION,
    PTVerificationTypes.COMMERCIAL_EQUIPMENT_CONDITION,
    PTVerificationTypes.COMMERCIAL_EQUIPMENT_EXISTENCE,
    PTVerificationTypes.COMMERCIAL_EQUIPMENT_CUSTODY,
    PTVerificationTypes.COMMERCIAL_EQUIPMENT_SUPPLIER,
    PTVerificationTypes.COMMERCIAL_EQUIPMENT_INSTALLATION,
    PTVerificationTypes.COMMERCIAL_EQUIPMENT_SPECIFICATION,
    PTVerificationTypes.COMMERCIAL_EQUIPMENT_IDENTITY_TAMPER,
  ],
  [AssetType.PRECIOUS_METAL]: [
    PTVerificationTypes.PRECIOUS_METAL_VALUATION,
    PTVerificationTypes.PRECIOUS_METAL_AUTHENTICITY,
    PTVerificationTypes.PRECIOUS_METAL_EXISTENCE,
    PTVerificationTypes.PRECIOUS_METAL_CUSTODY,
  ],
  [AssetType.RESIDENTIAL]: [
    PTVerificationTypes.RESIDENTIAL_REAL_ESTATE_VALUATION,
    PTVerificationTypes.RESIDENTIAL_REAL_ESTATE_DIMENSIONS,
    PTVerificationTypes.RESIDENTIAL_REAL_ESTATE_EXISTENCE,
    PTVerificationTypes.RESIDENTIAL_REAL_ESTATE_CUSTODY,
  ],
  [AssetType.COMMERCIAL]: [
    PTVerificationTypes.COMMERCIAL_REAL_ESTATE_VALUATION,
    PTVerificationTypes.COMMERCIAL_REAL_ESTATE_DIMENSIONS,
    PTVerificationTypes.COMMERCIAL_REAL_ESTATE_EXISTENCE,
    PTVerificationTypes.COMMERCIAL_REAL_ESTATE_CUSTODY,
  ],
  [AssetType.INDUSTRIAL]: [
    PTVerificationTypes.INDUSTRIAL_REAL_ESTATE_VALUATION,
    PTVerificationTypes.INDUSTRIAL_REAL_ESTATE_DIMENSIONS,
    PTVerificationTypes.INDUSTRIAL_REAL_ESTATE_EXISTENCE,
    PTVerificationTypes.INDUSTRIAL_REAL_ESTATE_CUSTODY,
  ],
  [AssetType.AGRICULTURAL]: [
    PTVerificationTypes.AGRICULTURAL_LAND_PARCEL_VALUATION,
    PTVerificationTypes.AGRICULTURAL_LAND_PARCEL_DIMENSIONS,
    PTVerificationTypes.AGRICULTURAL_LAND_PARCEL_EXISTENCE,
    PTVerificationTypes.AGRICULTURAL_LAND_PARCEL_CUSTODY,
  ],
  [AssetType.NON_AGRICULTURAL]: [
    PTVerificationTypes.NON_AGRICULTURAL_LAND_PARCEL_VALUATION,
    PTVerificationTypes.NON_AGRICULTURAL_LAND_PARCEL_DIMENSIONS,
    PTVerificationTypes.NON_AGRICULTURAL_LAND_PARCEL_EXISTENCE,
    PTVerificationTypes.NON_AGRICULTURAL_LAND_PARCEL_CUSTODY,
  ],
  [AssetType.INDUSTRIAL_ALLOTMENT]: [
    PTVerificationTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_VALUATION,
    PTVerificationTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_DIMENSIONS,
    PTVerificationTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_EXISTENCE,
    PTVerificationTypes.INDUSTRIAL_ALLOTMENT_LAND_PARCEL_CUSTODY,
  ],
  [AssetType.RESIDENTIAL_PLOT]: [
    PTVerificationTypes.RESIDENTIAL_PLOT_LAND_PARCEL_VALUATION,
    PTVerificationTypes.RESIDENTIAL_PLOT_LAND_PARCEL_DIMENSIONS,
    PTVerificationTypes.RESIDENTIAL_PLOT_LAND_PARCEL_EXISTENCE,
    PTVerificationTypes.RESIDENTIAL_PLOT_LAND_PARCEL_CUSTODY,
  ],
  [AssetType.COMMERCIAL_PLOT]: [
    PTVerificationTypes.COMMERCIAL_PLOT_LAND_PARCEL_VALUATION,
    PTVerificationTypes.COMMERCIAL_PLOT_LAND_PARCEL_DIMENSIONS,
    PTVerificationTypes.COMMERCIAL_PLOT_LAND_PARCEL_EXISTENCE,
    PTVerificationTypes.COMMERCIAL_PLOT_LAND_PARCEL_CUSTODY,
  ],
  
  [AssetType.FIXED_DEPOSIT]: [PTVerificationTypes.OTHERS],
  [AssetType.MARKETABLE_SECURITY]: [PTVerificationTypes.OTHERS],
  [AssetType.GOVERNMENT_DEBT_INSTRUMENT]: [PTVerificationTypes.OTHERS],
  [AssetType.SMALL_SAVINGS_SCHEME]: [PTVerificationTypes.OTHERS],
  [AssetType.INSURANCE_SECURITY_ASSET]: [PTVerificationTypes.OTHERS],
  [AssetType.STOCK_AND_INVENTORY]: [PTVerificationTypes.OTHERS],
  [AssetType.TRADE_RECEIVABLE]: [PTVerificationTypes.OTHERS],
  [AssetType.CORPORATE_GUARANTEE]: [PTVerificationTypes.OTHERS],
};

export const getSupportedDocumentTypesForAssets = (assets: Asset[]): PTVerificationTypes[] => {
  const supportedTypes = new Set<PTVerificationTypes>();

  assets.forEach((asset) => {
    const typesForAsset = ASSET_TYPE_TO_PT_VERIFICATION_MAP[asset.asset_type] || [];
    typesForAsset.forEach((type) => supportedTypes.add(type));
  });

  return Array.from(supportedTypes);
};